const googleAnalyticsScript = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){
    dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', {$SITE-ID});
`
export default googleAnalyticsScript